import { render, staticRenderFns } from "./distinction.vue?vue&type=template&id=153b3690&"
import script from "./distinction.vue?vue&type=script&lang=js&"
export * from "./distinction.vue?vue&type=script&lang=js&"
import style0 from "./distinction.vue?vue&type=style&index=0&id=153b3690&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports